// extracted by mini-css-extract-plugin
var _1 = "ChatroomMessagesUnreadDivider-modulechatroomMessagesUnreadDivider__Oe1Nz";
var _2 = "ChatroomMessagesUnreadDivider-modulelabel__BEW1k";
export { _1 as "chatroomMessagesUnreadDivider", _2 as "label" }
